import {
  GetOppLineItemsRequest,
  GetOppLineItemsResponse,
} from '@cbinsights/salesforceservice/salesforceservice';
import { request } from 'client/modules/common/utils/request';

export const getOppLineItems = (
  req: Partial<GetOppLineItemsRequest>
): Promise<GetOppLineItemsResponse> => {
  return request({
    url: '/service/salesforceservice/GetOppLineItems',
    body: req,
  }).then((r) => r.body);
};
